import { isEmpty } from 'lodash';
import { API, METHODS } from '../../constants';
import { fetchData } from '../common/apiCalling';
import { constructURL } from '../common';

export const signedDigitalLaborLawPosterFile = ({ signedData }) => {
    const url = `${API.SIGNED_DLLP_URL}`;
    return fetchData({ body: signedData, method: METHODS.POST, url });
};

export const updateDigitalLaborLawPoster = ({ data, id }) => {
    const url = `${API.DIGITAL_LABOR_POSTER}/${id}`;
    return fetchData({ body: data, method: METHODS.PUT, url });
};

export const createDigitalLaborLawPoster = ({ body }) => {
    const url = `${API.DIGITAL_LABOR_POSTER}`;
    return fetchData({ body: body, method: METHODS.POST, url });
};

export const getAllDigitalLaborLawPoster = ({ offset, limit, search = '', filter, account_id }) => {
    const queryParams = {
        offset: offset ? offset : '',
        account_id: account_id || '',
        limit: limit ? limit : '',
        search: search ? encodeURIComponent(search) : '',
        filter: !isEmpty(filter) ? encodeURIComponent(JSON.stringify(filter)) : '',
    };
    const url = constructURL(API.DIGITAL_LABOR_POSTER, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

export const deleteDigitalLaborLawPoster = ({ data }) => {
    const url = `${API.DIGITAL_LABOR_POSTER}`;
    return fetchData({ body: data, method: METHODS.DELETE, url });
};
